// @flow
import _ from 'lodash'

export default function matchesNotFloat(s: string): boolean {
  return !_.isEmpty(s.match(/[^0-9.]/)) || !_.isEmpty(s.match(/.*\..*\..*/))
}
